import { LOCALES } from "../../i18n/locales";
import React from "react";
import { useLocale } from "../../i18n/LocaleProvider";

const LABELS = { ru: "RU", en: "EN", ko: "KO" };

const LanguageSwitcher = () => {
  const { lang, setLang } = useLocale();
  return (
    <div className="btn-group" role="group" aria-label="Language">
      {LOCALES.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLang(code)}
          className={`btn btn-sm ${
            lang === code ? "btn-primary" : "btn-outline-secondary"
          }`}
        >
          {LABELS[code]}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
